import React from 'react'
import DragContainer, {addItemToArray} from './DragContainer'
import DragGroup from './DragGroup'
import DragItem from './DragItem'
import { randomReactKey } from '../../utilities'

export default function Draggable(props) {

    const reorderGroups = (groupFrom, itemFrom, groupTo, dropzoneTo) => {
        props.setGroups((previousState) => {
            const newGroups = addItemToArray(previousState, groupFrom, itemFrom, groupTo, dropzoneTo)
            
            // Reset the dropzone
            const dropzone = document.querySelector('div.dropped')
            dropzone.innerHTML = ''
            dropzone.classList.remove('dropped')
            dropzone.classList.add('empty')

            return newGroups
        })

        props.setDropped(true)
    }

    const formattedGroups = props.groups?.length ? props.groups.map((group) => {
        const id = group.id
        const categoryName = group.categoryName
    
        return {
            id,
            categoryName,
            items: 
                <DragGroup
                    key={randomReactKey()}
                    isHistoryDate={props.isHistoryDate}
                    dataIndexes={group.dataIndexes}
                    reorderGroups={props.isHistoryDate ? null : reorderGroups}
                    lastDropzoneIndex={group.items.length}
                    status={group.status}
                    toggleGroupCollapseStatus={props.toggleGroupCollapseStatus}
                >
                    {group.items.map((item) => <DragItem
                        key={randomReactKey()}
                        isHistoryDate={props.isHistoryDate}
                        dataIndexes={item.dataIndexes.length === 1 ? [-1, item.dataIndexes[0]] : item.dataIndexes}
                        id={item.id}
                        reorderGroups={reorderGroups}
                        status={item.status}
                        updatedAt={item.updatedAt}
                        lang={props.lang}
                        subPage={props.subPage}
                        setSubPage={props.setSubPage}
                        setCurrentDataIndexes={props.setCurrentDataIndexes}
                        isTheOnlyCategory={props.groups[0].dataIndexes[0] === -1 && props.groups[0].items.length === 1}
                        setIsSelectingStatus={props.setIsSelectingStatus}
                        isSelectingStatus={props.isSelectingStatus}
                        changeStatus={props.changeStatus}
                        setNewTextValue={props.setNewTextValue}
                        itemText={item.text}
                    >
                        <div>
                            {item.text}
                        </div>
                    </DragItem>)}
                </DragGroup>
        }
    }) : [{categoryName: '', items: []}]

    return <DragContainer
        isHistoryDate={props.isHistoryDate}
        showCalendar={props.showCalendar}
        disabled={props.disabled}
        formattedGroups={formattedGroups}
        lang={props.lang}
        subPage={props.subPage}
        setSubPage={props.setSubPage}
        setCurrentDataIndexes={props.isHistoryDate ? null : props.setCurrentDataIndexes}
        setNewTextValue={props.isHistoryDate ? null : props.setNewTextValue}
        isEditingGroups={props.isHistoryDate ? null : props.isEditingGroups}
        setIsAddingCategory={props.isHistoryDate ? null : props.setIsAddingCategory}
    />
}